import { useAppDispatch, useAppSelector } from "@app/store";
import { useUserId } from "@hooks/use-user-id";
import { useCallback } from "react";
import { OrderForm, RequisiteOrdersForm } from "./api";
import {
  confirmOrder,
  getOrders,
  getRequisiteOrders,
} from "./slice";

export const useOrders = () => {
  const state = useAppSelector((state) => state.order);
  const methods = useOrdersDispatch();

  return {
    state,
    ...methods,
  };
};

export const useOrdersDispatch = () => {
  const userId = useUserId();
  const dispatch = useAppDispatch();

  const getOrdersHandler = useCallback(
    (data: OrderForm) => dispatch(getOrders({ userId, data })),
    [dispatch, userId]
  );



  const confirmOrderHandler = useCallback(
    (orderId: string) => dispatch(confirmOrder({ orderId, userId })),
    [dispatch, userId]
  );

  const getRequisiteOrdersHandler = useCallback(
    (requisiteId: string, data: RequisiteOrdersForm) =>
      dispatch(getRequisiteOrders({ requisiteId, data })),
    [dispatch]
  );

  return {
    getOrders: getOrdersHandler,
    confirmOrder: confirmOrderHandler,
    getRequisiteOrders: getRequisiteOrdersHandler,
  };
};
